import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLajmerimeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 15.208,
	viewBox: "0 0 20 15.208",
	fill: "#121212",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_5744",
		"data-name": "Group 5744",
		transform: "translate(-426 -450.391)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8272",
				"data-name": "Path 8272",
				d: "M18,12h0a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H19A1,1,0,0,0,18,12Z",
				transform: "translate(424 446)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8273",
				"data-name": "Path 8273",
				d: "M16.59,16.82a.966.966,0,0,0,.2,1.37c.53.39,1.09.81,1.62,1.21a.978.978,0,0,0,1.38-.2c0-.01.01-.01.01-.02a.978.978,0,0,0-.2-1.38c-.53-.4-1.09-.82-1.61-1.21a.993.993,0,0,0-1.39.21A.035.035,0,0,1,16.59,16.82Z",
				transform: "translate(424 446)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8274",
				"data-name": "Path 8274",
				d: "M19.81,4.81c0-.01-.01-.01-.01-.02a.98.98,0,0,0-1.38-.2c-.53.4-1.1.82-1.62,1.22a.979.979,0,0,0-.19,1.38c0,.01.01.01.01.02a.979.979,0,0,0,1.38.2c.53-.39,1.09-.82,1.62-1.22A.994.994,0,0,0,19.81,4.81Z",
				transform: "translate(424 446)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8275",
				"data-name": "Path 8275",
				d: "M8,9H4a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2H5v3a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V15H8l5,3V6Z",
				transform: "translate(424 446)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_8276",
				"data-name": "Path 8276",
				d: "M15.5,12A4.48,4.48,0,0,0,14,8.65v6.69A4.442,4.442,0,0,0,15.5,12Z",
				transform: "translate(424 446)"
			})
		]
	})
});
export { SvgLajmerimeIcon as ReactComponent };
